"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "godiasco-salice-terme": {
    "93f61fe7": [{
      "hkey": "b8e0cc1c",
      "slug": "montealfeo",
      "name": "Montealfeo",
      "primary": true,
      "skipSearch": false
    }],
    "monte-alfeo": [{
      "hkey": "b8e0cc1c",
      "slug": "montealfeo",
      "name": "Montealfeo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "df161afb": [{
      "hkey": "4b91408a",
      "slug": "san-giovanni",
      "name": "San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni-piumesana": [{
      "hkey": "4b91408a",
      "slug": "san-giovanni",
      "name": "San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;